export default __webpack_public_path__ + "static/media/5.334a9c98.png";